import { useState } from 'react';

export const useDeleteChat = (API_URL) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteChat = async (conversationId) => {
    if (!API_URL) return;

    setIsDeleting(true);
    const deleteUrl = `${API_URL}/delete_chat`;

    try {
      const response = await fetch(deleteUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ conversation_id: conversationId }),
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log(`Chat history removed successfully (${result}): ${conversationId}`);
      return true;
    } catch (error) {
        console.error(`Error removing chat history (${error}): ${conversationId}`, error);
      return false;
    } finally {
      setIsDeleting(false);
    }
  };

  return { deleteChat, isDeleting };
};
